import type {
  CheckAbusePatternsResponse,
  FollowArtistSuccessResponse,
  UnfollowArtistSuccessResponse,
  GetUserRelationsResponse,
} from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from './helpers'

/**
 * Follow an artist (by screen name, logged-in user)
 */
export async function followUser(artistId: string, idToken: string): Promise<FollowArtistSuccessResponse> {
  return secureFetch<FollowArtistSuccessResponse>(`${SECURE_API_BASE}/follow/${encodeURIComponent(artistId)}`, idToken, {
    method: 'POST',
  })
}

/**
 * Unfollow an artist (by screen name, logged-in user)
 */
export async function unfollowUser(artistId: string, idToken: string): Promise<UnfollowArtistSuccessResponse> {
  return secureFetch<UnfollowArtistSuccessResponse>(`${SECURE_API_BASE}/follow/${encodeURIComponent(artistId)}`, idToken, {
    method: 'DELETE',
  })
}

/**
 * Fetch all user relations (favorites, following, followers) for the logged-in user.
 */
export async function fetchUserRelations(idToken: string): Promise<GetUserRelationsResponse> {
  return secureFetch<GetUserRelationsResponse>(`${SECURE_API_BASE}/user-relations`, idToken, {
    method: 'GET',
  })
}

/**
 * Check for abuse patterns
 */
export async function checkAbusePatterns(idToken: string): Promise<CheckAbusePatternsResponse> {
  return secureFetch<CheckAbusePatternsResponse>(`${SECURE_API_BASE}/abuse-check`, idToken, {
    method: 'GET',
  })
}
